export default defineNuxtPlugin(() => {
  const newToken = parseToken(location.href)
  if (newToken === undefined) {
    return
  }

  const tokens = useTokensStore()
  tokens.staffToken = newToken
})
